import { apiRequest } from "../index";

export const getUserById = async () => {
  return apiRequest(`/api/common/settings`, "GET");
};

export const getSettings = async () => {
  return apiRequest(`/api/common/hotels-visibility`, "GET");
};

export const getUser = async (token) => {
  return apiRequest(`/api/common/settings`, "GET" , null, false, null, token);
};

export const getHotelsRestaurantsListing = async ({showRestaurants }) => {
  return apiRequest(`/api/common/hotels-restaurants?showRestaurants=${showRestaurants}`, "GET");
};

export const getAds = async ({showRestaurants }) => {
  return apiRequest(`/api/common/ads?showRestaurants=${showRestaurants}`, "GET");
};

export const subscribeNewsletter = async (payload) => {
  return await apiRequest(`/api/common/newsletter/subscribe`, "POST", payload);
};